module.exports = __webpack_public_path__ + "static/graph-dbf4ba2b843bf022411454f057e3cf73.jpg";